import { isNil } from 'lodash'

export const mapPropertyOrDefault = (mapper, property, defaultValue = {}) => {
  if (isNil(property)) {
    return defaultValue
  }

  return Array.isArray(property)
    ? property.map(p => mapper(p))
    : mapper(property)
}

export default {
  mapPropertyOrDefault
}
